import {
	title
} from 'echarts/lib/theme/dark';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
	common: {
		setbtn: '已設置',
		link: '友情鏈接',
		more: '更多資訊 ',
		website: '官網',
		global: '全球',
		goods: '商品',
		service: '服務',
		mallExchange1: ' 直聯商家 ',
		mallExchange2: ' 鏈商平台 ',
	},
	commonTime: {
		minute1: '1分鐘',
		minute5: '5分鐘',
		minute15: '15分鐘',
		minute30: '30分鐘',
		hour1: '1小時',
		hour2: '2小時',
		hour4: '4小時',
		day1: '1天',
		week1: '1周',
		month1: '1個月',
	},
	tipsVal: {
		copyerror: '復製失敗！',
		copySucess: '復製成功！',
		noDataTips: '暫無數據哦~',
		noBankCardTips: '還未添加銀行卡信息哦~',
		inputPlaceholder: '請輸入內容',
		inputPlaceholder1: '請輸入',
		networkType: '網絡類型',
		phone: '手機',
		logoutTips: '此操作將退出, 是否繼續?',
		setChoiceAddress: '設置提幣地址',
		userAuthenticate: '未進行身份認證'
	},
	verifyUser: {
		title: "身份認證",
		country: "居住地",
		name: "名",
		familyName: "姓",
		idcardNo: "證件號碼",
		upload: "上傳",
		reminder: "註意",
		reminderValue: "· 確保您的姓名和證件號碼在照片上清晰可見",
		tips: {
			type: "PEG or PNG格式，",
			size: "不超過2MB",
			idcardImg: "請上傳證件照片",
			idcardFrontImgurl: "以PNG或JPEG格式上傳身份證件首頁的照片",
			idcardBackImgurl: "以PNG或JPEG格式上傳身份證背面",
		}
	},
	vip: {
		register: '註冊用戶',
		member: '會員用戶',
		copartner: '合夥人',
		diamond: '鉆石合夥人'
	},
	news: {
		title: "新聞活動與公告",
		titleInfo: "聚焦行業深度與前沿，深度解析趨勢和機遇",
		tabVal1: '系統通知',
		tabVal2: '平臺公告',
		tabVal3: '新聞活動',
		moreTips: '更多公告',
		noDataTips: '暫無公告內容哦~'
	},
	buy_box: {
		buy: '買入',
		buy_price: '買價',
		sell: '賣出',
		sell_price: '賣價',
		use: '可用',
		amount: '數量',
		money: '金額',
		loading: '登錄',
		add_success: '委托成功',
		trans_confirm: '交易確認',
		buy_confirm: '確認買入',
		sell_confirm: '確認賣出',
		trans_amount: '交易額',
		trans_password_placeholder: '請輸入交易密碼',
		confirm: '確認',
		cancel: '取消',
		verification: '驗證',
		withdraw: '提現',
		chain_withdraw: '鏈上提現',
		input_error: '金額或者數量必須大於0'
	},
	nav: {
		home: '首頁',
		mall: '商城',
		ctc: '二手市場',
		otc: '法幣交易',
		faq: '常見問題',
		partner: '會員計劃',
		financial: 'RWA理財',
		burst: '爆塊獎勵',
		apply: '上幣申請',
		download: 'APP下載',
		order: '訂單',
		assets: '資產',
		login: '登錄/註冊',
		mine: '我的',
		ann_more: '查看更多>>',
		ann_drop: {
			system: '系統通知',
			ann: '平臺公告',
			news: '行業新聞',
			login: '登錄後可查看',
		},
		user_drop: {
			partner_register: '註冊用戶',
			partner_member: '會員用戶',
			partner_partner: '合夥人',
			partner_diamond: '鉆石合夥人',
			center: '個人中心',
			address: '提幣地址管理',
			order: '訂單管理',
			receipt: '收款設置',
			api: 'API管理',
			out: '退出'
		}
	},
	mall: {
		title: "商城",
		status1: "進行中",
		status2: "未開始",
		status3: "認購結束",
		status4: "認購N/A",
		assetType: "資產類別",
		assetTime: "發行時間",
		assetPrice: "發行價格",
		issuanceTotal: "發行總量",
		outstandingUnits: "流通總量",
		delivery: "配送區域",
		payPrice: "最低購買量",
		mallUrl: "鏈商平臺",
		showDetail: "點擊查看",
		detail: {
			title: '商品詳情',
			type: 'BNB智能鏈',
			typeInfo: '由MEIMEI INTERNATIONAL HOLDINGS LIMITED發行',
			btn1: '進入二手市場',
			btn2: '商鏈平臺',
			tab1: '詳情',
			tab2: '文檔',

			goodsType: "產品類型",
			mallExchange: "兌　　換",
			debutStartTime: "首發開始",
			debutEndTime: "首發結束",
			goodsName: "上架名稱",
			symbol: "簡稱",
			network: "網絡",
			protocol: "協議",
			contract: "合約地址",
			issuer: "發行方",
			publishAmount: "發行總量",
			tradeAmount: "交易總量",
			decimal: "精度",
			totalValue: "發行總額",
			firstValue: "首單發行",
			minBuyAmount: "最小購買量",
			maxBuyAmount: "最大購買量",
			showWhitePage: "查看白皮書",

			chainInfo: "鏈上信息",
			view: "查看",
			hide: "隱藏",

			noData: "暫無商城產品哦~",

			coinInfo1: '香港100強上市企業聯盟有限公司',
			coinInfo2: 'RWA Group Limited',
			coinInfo3: 'Meimei International Holdings Limited',
		}
	},
	question: {
		title: "常見問題",
		info1: 'RWA.LTD為用戶提供了一個怎樣的平臺？',
		infoText1: 'RWA.LTD為用戶提供了一個怎樣的平臺？',
		info2: '註冊平臺用戶的要求和限製',
		infoText2: '註冊平臺用戶的要求和限製',
		info3: '註冊平臺用戶的要求和限製',
		infoText3: '本平臺對於已完成KYC認證的用戶推出邀請獎勵活動，若受邀用戶通過邀請鏈接或邀請碼在本平臺註冊賬戶並完成KYC認證，發出邀請的用戶未來可以獲得受邀用戶買入交易的手續費返傭(比例為一級15%，二級5%)。在KYC認證通過後，您可以在「個人中心-賬號管理-查看我的邀請」中獲得邀請碼，新用戶也可以通過點擊邀請鏈接與您綁定邀請關系。本平臺保留隨時更改前述活動內容或者取消前述活動的權利，此類「更新」或者「取消」可能並不會及時反映在此。',
		info4: '為何不能成功註冊或登錄？',
		infoText4: '為何不能成功註冊或登錄？',
		info5: '如何購買平臺創世代幣RWA Coin(「RWA」)?',
		infoText5: '如何購買平臺創世代幣RWA Coin(「RWA」)?',
	},
	home: {
		header: {
			title1: '鏈商平臺 重磅來襲',
			title2: '代幣機製和商品經濟的創新性結合，為您帶來全新體驗',
			title: 'RWA交易所',
			con: '百萬富翁合夥人計劃',
			rules: '查看活動詳情>>',
			member_num: '會員人數',
			register_num: '註冊用戶',
			register_btn: '點擊註冊',
		},
		table: {
			header: {
				userCollect: '自選',
				search: '搜索交易幣種'
			},
			row: {
				rwatype: 'RWA代幣',
				type: '交易對',
				price: '二手指導價',
				high: '24H最高價',
				low: '24H最低價',
				rang: '24H漲跌幅',
				volume: '24H交易量',
				amount: '24H成交額'
			},
			more: '查看更多'
		},
		introduction: {
			h1: 'RWA交易所，全球最大的會員製交易所',
			h3: '為全球用戶提供安全、可信賴的數字資產交易及資產管理服務，與全球會員共享平臺紅利',
			part1: {
				title: '獨創會員製',
				con: '采用社區共建、讓利會員的方式，打造全球最大的會員製交易所'
			},
			part2: {
				title: '系統穩定可靠',
				con: '多層多集群系統架構、高性能撮合引擎技術、銀行級用戶數據加密、動態身份驗證等，保障交易安全'
			},
			part3: {
				title: '資金安全有保障',
				con: '多重簽名、離線簽名、冷熱錢包疊合等先進的技術，為客戶提供安全、可信賴的數字資交易服務'
			},
			title: {
				merchant1: '賣家',
				merchant2: '買家',
				text1: '創新性改革商品經濟',
				text2: 'RWA.LTD 透過代幣機制和商品市場的創新結合，為買家和賣家各自提供 WEB3 紀元下的交易渠道和交易模式。',
				text3: '客製化非金融性品牌代幣方案',
				text4: '品牌方為何前來？前置營收現金流 + 可預見性輕量運營 + 高效管理的品牌粉絲流量社群',
				text5: '確享無門檻代幣零售交易 ',
				text6: '消費者為何前來？7×24 小時不間斷鏈上交易 + 隨時脫粉品牌的理由 + 更具吸引力的預售價格 + 隨時轉讓的「新鮮」囤貨',
				text7: '將商品經濟改寫為鏈商經濟',
				text8: '透過包羅萬象卻質規上乘的非金融性資產選品，面向每一個人的零售用戶畫像設計，以及突破性的交易收藏一體化集成，RWA.LTD 立足實體經濟，以用戶權益為第一出發點，力求為所有人提供一個值得信賴的、有價值依托的並且能切實運用區塊鏈技術紅利的代幣交易平台。',
				text9: '新聞活動與公告',
				text10: '更多公告',
			}
		},
		download: {
			title: '隨時隨地，交易更輕松',
			con: 'RWA交易所為用戶提供交易終端，支持IOS、Android和Web，並為專業交易者提供毫秒級延遲的API服務 語言涵蓋中文、英文等，致力於為客戶提供一流的投資體驗',
			ios: 'IOS下載',
			android: 'Android下載'
		},
		register: {
			title: '註冊RWA賬號，開啟數字貨幣之旅',
			placeholder: '請輸入手機號或郵箱',
			btn: '立即註冊'
		},
		footer: {
			about: '關於我們',
			legal: ' 平台條款 ',
			terms: '用戶協議',
			buyProtocol: '購買協議',
			questions: '常見問題',
			ecosystem: '生態系統',
			rwaApp: 'RWA應用',
			emailAddress: '郵箱地址',
			companyaddress: '公司地址',
			production: '產品',
			question: '問題反饋',
			rate: '費率標準',
			partner: '成為合夥人',
			apply: '上幣申請',
			api: 'API接入',
			app: 'APP下載',
			ann_help: '公告幫助',
			off_ann: '官方公告',
			help: '幫助中心',
			agreements: '用戶協議',
			privacy: '隱私政策',
			contact: '聯系我們',
			business: '商務合作',
			service: '客服',
			institutional: '機構合作'
		}
	},
	trade_ctc: {
		trans_start: '後開啟交易',
		header: {
			price: '二手指導價',
			change: '24小時漲跌幅',
			high: '24小時最高',
			low: '24小時最低',
			volume: '24小時成交量',
			search: '搜索幣種',
			self: '自選'
		},
		buyAndSell: {
			price: '價格',
			volume: '數量',
			money: '金額',
			limit_delegation: '限價委托',
			current_delegation: '當前委托',
			history_delegation: '歷史委托'
		},
		delegationTable: {
			time: '委托時間',
			pay_type: '交易類型',
			buy: '買入',
			sell: '賣出',
			amount: '委托數量',
			beenDone: '已成交',
			price: '委托價格',
			averagePrice: '成交均價',
			money: '成交總額',
			status: '狀態',
			trading: '交易中',
			un_trade: '未交易',
			canceled: '已取消',
			part_completed: '部分成交',
			canceling: '撤銷中',
			completed: '已成交',
			operation: '操作',
			cancel: '撤銷',
			cancel_success: '撤銷成功',
			deleteRecord: '刪除',
			delete_success: '刪除成功'
		},
		deal: {
			title: '最新成交',
			amount: '數量',
			price: '價格',
			time: '時間'
		},
		search: {
			placeholder: '搜索幣種',
			self: '自選',
			coin_type: 'RWA幣種',
			price: '最新價',
			range: '漲跌幅'
		}
	},
	login: {
		title1: '歡迎登錄',
		title: '歡迎登錄RWA',
		pwd: '密碼',
		tips: '還不是註冊用戶？',
		phone_login: '手機登錄',
		email: '郵箱',
		newemail: '新郵箱地址',
		newemailcode: '新郵箱驗證碼',
		email_login: '郵箱登錄',
		input_phone1: '手機號',
		input_phone: '手機號（僅支持中國大陸地區）',
		input_email: '請輸入郵箱',
		input_email1: '請輸入有效的郵箱',
		input_password: '請輸入密碼',
		login: '登錄',
		forget: '忘記密碼？',
		no_account: '還沒有賬號？',
		register_now: '立即註冊',
		verify: '驗&nbsp;&nbsp;&nbsp;&nbsp;證',
		close: '關&nbsp;&nbsp;&nbsp;&nbsp;閉',
		code_input: '請輸入驗證碼'
	},
	register: {
		title1: '歡迎註冊',
		title: '歡迎註冊RWA',
		phone: '手機號',
		register_phone: '手機註冊',
		register_email: '郵箱註冊',
		input_phone: '請輸入手機號',
		input_email: '請輸入郵箱',
		code: '驗證碼',
		get_code: '獲取驗證碼',
		input_code: '請輸入驗證碼',
		input_mes_code: '請輸入短信驗證碼',
		input_email_code: '請輸入郵箱驗證碼',
		input_password: '請設置登錄密碼，8～32位數字、字母或符號',
		confirm_password: '請再次輸入密碼',
		invite_code: '邀請碼',
		invite_code_tip: '請輸入邀請碼',
		register: '註冊',
		agree1: '我已閱讀並同意用戶協議',
		agree: '我已閱讀並同意',
		policy: '《用戶協議及隱私政策》'
	},
	alert: {
		register_success: '註冊成功'
	},
	validate: {
		account_require: '賬號不能為空',
		password_require: '密碼不能為空',
		code_require: '驗證碼不能為空',
		mes_code_require: '短信驗證碼不能為空',
		email_code_require: '郵箱驗證碼不能為空',
		google_code_require: '谷歌驗證碼不能為空',
		password_formatter_error: '密碼格式錯誤',
		password_formatter_tip: '密碼為8到32個數字與字母的組合',
		password_confirm_again: '請再次輸入密碼',
		password_confirm_error: '密碼兩次輸入不一致',
		phone_require: '請輸入手機號碼',
		email_require: '請輸入郵箱',
		email_formatter_error: '郵箱格式錯誤',
		country_require: '請選擇居住地',
		name_require: '姓不能為空',
		familyName_require: '名不能為空',
		id_require: '證件號不能為空',
		depositBank_require: '開戶銀行不能為空',
		bankNum_require: '銀行卡號不能為空',
		bankNum_confirm_error: '兩次輸入的卡號不一致',
		trans_password_require: '交易密碼不能為空',
		trans_password_formatter_tip: '交易密碼為6～32位數字或字母',
		alipay_account_require: '支付寶賬號不能為空',
		wechat_account_require: '微信賬號不能為空',
		geet_require: '請完成驗證',
		agree_require: '請先閱讀用戶協議',
		address_require: '地址不能為空',
		amount_require: '數量不能為空',
		amount_min: '不能小於',
		amount_over_0: '請輸入大於0的數字',
		type_number: '必須為數字',
		incomplete_information: '信息未完善',
		coin_type_error: '幣種填寫有誤',
		alias_require: '地址別名不能為空',
		invite_code_require: '邀請碼不能為空',
		description_require: '備註不能為空',
		roles_require: '請選擇API權限',
		qr_code_require: '請上傳二維碼',
		upload_error: '上傳圖片失敗!',
		upload_type: '上傳圖片只能是 JPG、JPEG 或者 PNG 格式!',
		upload_size: '上傳頭像圖片大小不能超過 2MB!',
		upload_compress: '圖片較大，正在壓縮中...',
		input_err_tips: "請輸入正確的內容~"
	},
	user_center: {
		tip: '提示',
		tip_val2: '使用於法幣合規出入金，請務必使用本人賬戶並確保信息正確可靠！',
		my_share: '我的邀請',
		my_invite_code: '我的邀請碼',
		securitySettings: '安全設置',
		login_history: '登錄歷史',
		login_safety_history: '安全設置歷史',
		login_text: '賬戶登錄',
		login_out_text: '退出賬號',
		copy_share_url: '復製邀請鏈接',
		share_tips_val: '每天08:00:00 (GMT+0800) 將返還前24小時邀請邀請獎勵，直接發放到幣幣賬戶，請註意查收。',
		accountManagement: '賬號管理',
		accountSettings: '賬號設置',
		apiManagement: 'API管理',
		paySettings: '收款設置',
		orderManagement: '訂單管理',
		see_user_share: '查看我的邀請',
		update_user_img: '更換頭像',
		need_bind: '需要同時綁定手機號與郵箱',
		need_bind1: '需要同時綁定谷歌驗證器與郵箱',
		bind_now: '現在綁定',
		need_tran_password: '需要設置交易密碼',
		set_now: '現在設置',
		need_auth: '需要身份審核',
		kyc_phone: '請在手機端進行身份認證',
		i_know: '我知道了',
		cancel: '取消',
		base_info: {
			title: '基礎信息'
		},
		account_setting: {
			title: '賬戶設置',
			add: '添加',
			manage: '管理',
			setting: '設置',
			address: {
				title: '提幣地址管理',
				tip: '地址認證,安全保障',
			},
			receipt: {
				title: '收款設置',
				tip: '保障賬戶安全'
			},
			api: {
				title: 'API設置',
				tip: '創建API密鑰'
			}
		},
		account_safe: {
			title: '賬戶安全',
			title_tip: '至少保留兩種驗證方式',
			authenticate: '認證',
			not_authenticate: '未認證',
			has_authenticate: '已認證',
			has_authenticate_lvl: '已高級認證',
			ing_authenticate: '審核中',
			fail_authenticate: '審核失敗',
			fail_reason: '失敗原因:',
			authenticate_again: ',是否重新認證？',
			again: '重新認證',
			close: '關閉',
			detail: '詳情',
			bind: '綁定',
			setting: '設置',
			has_bind: '已綁定',
			not_bind: '未綁定',
			open: '開啟',
			not_open: '未開啟',
			has_open: '已開啟',
			change: '更換',
			modify: '修改',
			get_back: '找回',
			identity: {
				title: '身份認證',
				tipsVal: '身份核驗，為了您的權益'
			},
			login_password: {
				title: '登錄密碼',
				tip: '保障賬戶安全'
			},
			trade_password: {
				btn: '設置',
				title: '交易密碼',
				tip: '保障賬戶安全'
			},
			phone: {
				title: '手機綁定',
				tipsVal: '用於提現，修改密碼，安全設置時用於收取驗證短信'
			},
			email: {
				title: '郵箱設置',
				tipsVal: '用於登錄、提幣、安全設置時使用'
			},
			google: {
				title: '谷歌驗證',
				bind: '綁定谷歌',
				title1: '谷歌驗證碼',
				tipsVal: '用於提幣、找回密碼、修改安全設置、管理API時進行安全驗證',
				tipsVal2: '請先綁定谷歌驗證器'
			},
			authenticate_trade: {
				title: '交易驗證',
				tip: '保障賬戶安全'
			},
			alert: {
				con: '安全驗證關閉後，24小時無法提幣和OTC交易',
				close_phone_title: '確定關閉手機驗證？',
				close_email_title: '確定關閉郵箱驗證？',
				close_google_title: '確定關閉谷歌驗證？',
				cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
				confirm: '確&nbsp;&nbsp;&nbsp;&nbsp;定'
			}
		},
		table: {
			login_recently: {
				type: '類型',
				title: '最近登錄',
				time: '時間',
				ways: '登錄方式',
				status: '狀態',
				status1: '現狀',
				address: '登錄所在地',
				address1: '登錄地址',
				success: '登錄成功',
				error: '失敗',
				success1: '成功',
				fail: '登錄失敗'
			},
			setting_history: {
				title: '安全設置歷史',
				time: '時間',
				safe_setting: '安全設置',
				address: '登錄所在地'
			}
		}
	},
	phone_bind: {
		title: '綁定手機',
		success: '手機號綁定成功'
	},
	google_bind: {
		user_center: '個人中心',
		google_validate: '綁定谷歌驗證器',
		google_change: '更換谷歌驗證器',
		tip: '谷歌驗證器是一款動態口令工具，工作原理類似短信動態驗證。綁定後每30s生成一個動態驗證碼，驗證碼可用於登錄、提現、修改安全設置等操作的安全驗證。',
		download_title: '下載谷歌驗證器APP',
		download_desc: 'iOS用戶登錄App Store搜索「Authenticator」下載。安卓用戶登錄應用商店或使用手機瀏覽器搜索「谷歌驗證器」下載。',
		add_title: '在谷歌驗證器中添加密鑰並備份',
		add_desc: '打開谷歌驗證器，掃描下方二維碼或手動輸入下述密鑰添加驗證令牌。',
		copy_key: '復製秘鑰',
		add_tip: '密鑰用於手機更換或遺失找回谷歌驗證器，綁定前請務必獎下述密鑰備份保存。',
		change_tip: '更換綁定谷歌驗證器後，24小時內禁止提幣和OTC交易',
		input_code: '輸入谷歌驗證器中6位驗證碼',
		google_code_placeholder: '請輸入谷歌驗證碼',
		success_tip: '完成綁定',
		success_tip2: '密鑰用於手機更換或遺失時找回谷歌驗證器，綁定前請務必將上述密鑰備份保存。',
		next: '下一步',
		bind_title: '綁定谷歌安全驗證',
		change_title: '更換谷歌安全驗證',
		phone_code: '短信驗證碼',
		email_code: '郵箱驗證碼',
		get_code: '獲取驗證碼',
		code_placeholder: '請輸入驗證碼',
		email_code_tip: '若未收到郵件，請檢查郵箱垃圾箱',
		confirm: '確定',
		cancel: '取消',
		success: '谷歌驗證綁定成功',
		change_success: '谷歌驗證更換成功'
	},
	validation_off: {
		title_phone: '關閉手機驗證',
		tip_phone: '關閉手機驗證後24小時內禁止提幣和OTC交易',
		title_email: '關閉郵箱驗證',
		tip_email: '關閉郵箱驗證後24小時內禁止提幣和OTC交易',
		title_google: '關閉谷歌驗證',
		tip_google: '關閉谷歌驗證後24小時內禁止提幣和OTC交易',
		phone: '手機號',
		email: '郵箱',
		phone_placeholder: '請輸入手機號',
		phone_code: '短信驗證碼',
		code_placeholder: '請輸入驗證碼',
		email_code: '郵箱驗證碼',
		google_code: '谷歌驗證碼',
		confirm: '確定',
		phone_off_success: '手機驗證已關閉',
		email_off_success: '郵箱驗證已關閉',
		google_off_success: '谷歌驗證已關閉',
		google_lost: '谷歌驗證碼丟失？',
		please_click: '請點擊這裏'
	},
	validation_on: {
		title_phone: '開啟手機驗證',
		title_email: '開啟郵箱驗證',
		title_google: '開啟谷歌驗證',
		phone_open_success: '手機驗證開啟成功',
		email_open_success: '郵箱驗證開啟成功',
		google_open_success: '谷歌驗證開啟成功',
	},
	password_recovery: {
		title: '找回登錄密碼',
		title1: '重置登錄密碼',
		title3: '確認您的密碼',
		tip3: '修改密碼後24小時內禁止提幣',
		tip: '修改登錄密碼後24小時內禁止提幣',
		tip1: '至少 8 個字符並且存有數字字母',
		tip2: '已經是註冊用戶？',
		btn_login: '立即登錄',
		account: '郵箱',
		account_placeholder: '請輸入郵箱',
		mes_code: '短信驗證碼',
		email_code: '郵箱驗證碼',
		google_code: '谷歌驗證碼',
		getCode: '獲取驗證碼',
		code_placeholder: '請輸入驗證碼',
		nextStep: '下一步',
		password: '登錄密碼',
		update_password: '修改密碼',
		old_password: '原登錄密碼',
		new_password: '新登錄密碼',
		confirm: '確認密碼',
		password_placeholder: '請輸入密碼',
		submit: '提交',
		back: '返回',
		success: '密碼重置成功'
	},
	password_modify: {
		title: '修改登錄密碼',
		tip: '修改登錄密碼後24小時內禁止提幣和OTC交易',
		old_password: '當前登錄密碼',
		old_password_placeholder: '請輸入密碼',
		new_password: '請輸入密碼',
		new_password_placeholder: '請輸入新密碼',
		password_confirm: '確認新登錄密碼',
		password_confirm_placeholder: '請再次輸入密碼',
		mes_code: '短信驗證碼',
		email_code: '郵箱驗證碼',
		google_code: '谷歌驗證碼',
		google_placeholder: '請輸入谷歌驗證碼',
		getCode: '獲取驗證碼',
		code_placeholder: '請輸入驗證碼',
		submit: '提交',
		forget: '忘記登錄密碼',
		success: '登錄密碼修改成功'
	},
	set_trade_password: {
		title: '設置交易密碼',
		password_input: '請輸入交易密碼',
		password_formatter: '至少6位有效數字或字母',
		password_confirm: '確認密碼',
		phone_num: '手機號',
		mes_code: '短信驗證碼',
		email_code: '郵箱驗證碼',
		code_placeholder: '請輸入驗證碼',
		getCode: '獲取驗證碼',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		success: '交易密碼設置成功',
		bind_phone: '請先綁定手機號',
		email_phone: '請先綁定郵箱',
		go_bind: '去綁定'
	},
	modify_trade_password: {
		title: '修改交易密碼',
		password_input: '請輸入交易密碼',
		new_password_input: '請輸入新交易密碼',
		password_formatter: '至少6位有效數字或字母',
		password_confirm: '確認密碼',
		mes_code: '短信驗證碼',
		email_code: '郵箱驗證碼',
		google_code: '谷歌驗證碼',
		code_placeholder: '請輸入驗證碼',
		google_placeholder: '請輸入谷歌驗證碼',
		getCode: '獲取驗證碼',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		success: '交易密碼修改成功'
	},
	authentication: {
		title: '身份認證',
		country: '國籍',
		country_placeholder: '請選擇居住地',
		name: '姓名',
		name_placeholder: '請輸入姓名',
		IDType: '證件類型',
		IDCard: '身份證',
		passport: '護照',
		ID: '證件號碼',
		idNum_placeholder: '',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		tip: '· 為了您的資金安全，需驗證您的身份才可進行其他操作<br>' +
			'· 認證信息一經驗證不可修改，請務必如實填寫<br>' +
			'· 認證後可進行提幣、法幣交易等操作',
		front: {
			title: '本人身份證正面照片：',
			con: '· 請確保照片的內容完整並清晰可見<br>' +
				'· 支持jpg/png/jpeg圖片格式<br>' +
				'· 圖片大小不能超過2M'
		},
		back: {
			title: '本人身份證背面照片：',
			con: '· 請確保照片的內容完整並清晰可見<br>' +
				'· 身份證必須在有效期內<br>' +
				'· 僅支持jpg/png/jpeg圖片格式'
		},
		hand: {
			title: '本人手持證件照：',
			con: '· 請上傳一張手持證件正面照和個人簽字的照片<br>' +
				'· 個人簽字的內容包含手寫<label style="color: #F04C66">日期</label><br>' +
				'· 僅支持jpg/png/jpeg圖片格式'
		},
		success: '提交成功'
	},
	trade_auth_setting: {
		title: '交易驗證',
		tip: '關閉後，下單時不再需要密碼驗證',
		open: '始終開啟',
		close: '永久關閉',
		submit: '提&nbsp;&nbsp;&nbsp;&nbsp;交',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		input_password: '請輸入交易密碼',
		success: '修改成功'
	},
	email_bind: {
		title: '綁定郵箱',
		email: '郵箱',
		email_placeholder: '請輸入郵箱',
		email_code: '郵箱驗證碼',
		getCode: '獲取驗證碼',
		code_placeholder: '請輸入驗證碼',
		bind: '綁定',
		back: '返回',
		success: '郵箱綁定成功'
	},
	googleBind: {
		google_code: '谷歌驗證碼',
		code_placeholder: '請輸入驗谷歌驗證碼',
	},
	withdrawal_address_manage: {
		title: '提幣地址管理',
		add_address: '如何添加提幣地址？',
		coin_type: '幣種',
		network: "網絡",
		search_coin: '搜索幣種',
		another_name: '地址別名',
		another_name_placeholder: '請輸入地址別名',
		address: '提幣地址',
		address_placeholder: '請輸入或粘貼地址',
		memo_placeholder: '請輸入標簽',
		memo_tip: '如您被要求填寫地址標簽(Destination Tag)或數字ID或備註，請在此處填寫；反之則不需要填寫。',
		add: '添&nbsp;&nbsp;&nbsp;&nbsp;加',
		unbind: '未綁定',
		phone_code: '短信驗證碼',
		email_code: '郵箱驗證碼',
		google_code: '谷歌驗證碼',
		code_placeholder: '請輸入驗證碼',
		get_code: '獲取驗證碼',
		my_withdraw: '我的提幣',
		operation: '操作',
		withdraw: '提幣',
		del: '刪除',
		add_success: '添加成功',
		tip: '提示',
		delete_tip: '是否確定刪除',
		delete_btn: '刪除',
		cancel: '取消',
		delete_success: '刪除成功',
		go_bind: '去綁定'
	},
	receipt_money: {
		title: '收款設置',
		legal_tender: '法幣',
		receiptType: '收款方式',
		bankcard: '銀行卡',
		alipay: '支付寶',
		wechat: '微信',
		add: '添&nbsp;&nbsp;&nbsp;&nbsp;加',
		news_title: '新消息提醒<label style="color: #A0AAC1; font-size: 16px;">(我們會以郵件或短信的方式告知您OTC訂單的最新進展)</label>',
		email_notice: '郵件通知',
		phone_notice: '短信通知',
		table_title: '我的收款地址<label style="color: #A0AAC1; font-size: 16px;">(同種收款方式僅可添加一個賬號)</label>',
		account: '賬號',
		name: '姓名',
		bank_info: '銀行信息',
		operation: '操作',
		edit: '編輯',
		del: '刪除',
		dialog_title: '請填寫收款信息',
		deposit_bank: '開戶銀行',
		bank_address: '開戶地址',
		optional: '選填',
		bankcard_num: '銀行卡號',
		confirm_num: '確認卡號',
		input_again: '請再輸入一次',
		memo: '備註信息',
		trans_password: '交易密碼',
		input_trans_password: '請輸入交易密碼',
		submit: '確認資料',
		alipay_account: '支付寶賬號',
		upload_qr: '二維碼上傳',
		wechat_account: '微信賬號',
		add_success: '添加成功',
		save: '保存',
		edit_success: '編輯成功',
		tip: '提示',
		delete_tip: '是否確定刪除',
		delete_btn: '刪除',
		cancel: '取消',
		delete_success: '刪除成功',
		needRealName: '需要實名認證',
		authentication: '去認證'
	},
	order_manage: {
		ctc_order: '幣幣訂單',
		current_delegation: '當前委托',
		history_delegation: '歷史委托',
		coin_type: '幣種',
		all: '全部',
		all_direction: '全部方向',
		time_start: '開始時間',
		time_end: '結束時間',
		buy: '買入',
		sell: '賣出',
		search: '搜&nbsp;&nbsp;&nbsp;&nbsp;索',
		delete_order: '刪除無效訂單',
		time: '時間',
		symbol: '交易對',
		way: '方式',
		direction: '方向',
		limit: '限價',
		price: '價格',
		amount: '數量',
		total: '委托總額',
		dk: '消耗點卡',
		status: '狀態',
		had_cancel: '已撤銷',
		had_complete: '已完成',
		deal_concluded: '已成交數量',
		no_deal_concluded: '未成交',
		operation: '操作',
		order_id: '訂單號',
		done_price: '成交價',
		done_amount: '成交量',
		fee: '手續費',
		cancel: '撤銷',
		detail: '詳情',
		delete_record: '刪除',
		cancel_success: '撤銷成功',
		delete_success: '刪除成功',
		search: '搜索'
	},
	user_assets: {
		bankAccountNumber: '銀行賬號',
		overview: '資產概覽',
		total_assets: '總賬戶資產折合',
		ctc_account: '幣幣賬戶',
		little_assets_hide: '隱藏小額資產',
		member_card_title: '會員套餐',
		my_card_title: '我的點卡',
		check_detail: '查看詳情',
		search: '搜索幣種',
		coin_type: '幣種',
		available_balance: '可用余額',
		freeze_balance: '凍結余額',
		redeem: '贖回中',
		valuations: '估值',
		operation: '操作',
		recharge: '充幣',
		withdraw: '提幣',
		validate_warning: '需要開啟至少兩種驗證方式，請去個人中心開啟',
		can_not_recharge: '該幣種充幣功能暫時關閉',
		can_not_withdraw: '該幣種提幣功能暫時關閉',
		record: '交易記錄',
		recharge_address: '充幣地址',
		blockchain_type: '鏈類型',
		address_type: '地址類型',
		new_address: '新地址',
		old_address: '舊地址',
		check: '查看',
		recharge_record: '充幣記錄',
		copy_address: '復製地址',
		copy_memo: '復製Memo',
		copy_success: '復製成功',
		copy_error: '復製失敗',
		min_recharge: '最小充值金額：',
		recharge_warning: '小於最小金額的充值將不會上賬且無法退回。',
		memo_warning: '務必準確填寫',
		tip_title: '溫馨提示：',
		tip_con: '1.請勿向上述地址充值任何非 ETH 資產，否則資產將不可找回。<br>2.您充值至上指定地址後，需要 X 個網絡確認才能到賬。<br>' +
			'3.您的充值地址不會經常改變，可以重復充值；如有更改，我們會盡量通過網站公告或郵件通知您。<br>' +
			'4.請務必確認電腦及瀏覽器安全，防止信息被篡改或泄露。',
		choice_address: '選擇提幣地址',
		choice_address_placeholder: '請選擇提幣地址',
		withdraw_record: ' 提幣記錄',
		add_address: '添加新地址',
		withdraw_amount: '提幣數量',
		available: '可用：',
		withdraw_amount_placeholder: '請輸入提幣數量',
		withdraw_amount_placeholder1: ' 最小提幣數量為',
		withdraw_amount_placeholder2: ' 最大不超過',
		min_withdraw: '最小提幣金額為',
		withdraw_warning: '優先從余額中扣除，當余額不足則從提幣數量中扣除',
		withdraw_success: '提現成功',
		trans_password: '交易密碼',
		trans_password_placeholder: '請輸入交易密碼',
		buy_member: '您即將購買會員套餐，購買會員套餐後將享受會員權益，請先確認幣幣賬戶余額充足',
		buy_amount: '購買數量',
		should_pay: '應付金額',
		pay_confirm_title: '確認付款',
		pay_confirm: '確認支付',
		pay_success: '購買成功',
		available_not_enough: '余額不足',
		need_whole_number: '輸入值必須是正整數',
		cancel: '取&nbsp;&nbsp;&nbsp;&nbsp;消',
		phone_code: '短信驗證碼',
		phone_code_placeholder: '請輸入短信驗證碼',
		email_code: '郵箱驗證碼',
		email_code_placeholder: '請輸入郵箱驗證碼',
		get_code: '獲取驗證碼',
		phone_bind: '綁定手機號',
		email_bind: '綁定郵箱',
		google_code: '谷歌驗證碼',
		google_code_placeholder: '請輸入谷歌驗證碼',
		memo_tip: '·Memo錯填、漏填可能導致資產損失，請仔細核對<br><label class="font_color_red">·轉入交易所地址時必須填</label>',
		memo_placeholder: '請輸入MEMO',
		actual: '實際到賬數量：',
		fee: '手續費：',
		withdraw_btn: '提&nbsp;&nbsp;&nbsp;&nbsp;幣',
		my_dk: '我的點卡',
		available_dk: '點卡余額',
		buy_dk: '點卡購買',
		dk_desc: '點卡是RWA平臺推出的交易手續費充值卡，1點卡（dk）=1 USDT等值的交易手續費。',
		buy_placeholder: '請輸入購買數量',
		buy_btn: '購&nbsp;&nbsp;&nbsp;&nbsp;買',
		min_buy_amount: '最少購買金額',
		min_amount_warning: '購買金額不能少於最小金額',
		available_usdt: '可用USDT',
		api: {
			tips_val_1: '私有秘鑰允許您通過RWAEx開放協議提供API訪問您的賬戶並執行交易指令，我們為您提供的秘鑰非常重要，請妥善保管。',
			setting: 'API設置',
			check_document: '查看API文檔',
			attentionVal1: '1. 本平臺提供強大的API接口服務，包括市場數據查詢、交易等。請參考API文檔使用。商戶域名：openapi.rwa.ltd',
			attentionVal2: '2. 每個用戶最多可創建5個API密鑰集。',
			attentionVal3: '3.不要公開你的API密鑰以防止經濟損失。出於安全考慮，我們建議將IP地址綁定到你的API密鑰上。',
			attentionVal4: '4. 每個API密鑰支持綁定最多5個IP地址。用逗號分隔多個IP地址。',
			attention: '<label style="color: #F04C66">註意事項:</label><br>· 我們提供 REST 和 WebSocket API，可查閱API文檔。<br>· 每個用戶最多可創建10對API密鑰。<br>' +
				'· 針對交易API，單個IP限製每分鐘1000次訪問，超過1000次將被鎖定1小時，一小時後自動解鎖。<br>' +
				'· 針對交易API，單個API限製每秒鐘60次訪問，一秒鐘內60次以上的請求，將會視作無效。<br>· K線接口每秒只能請求一次數據。<br>' +
				'· 如果在使用過程中有任何問題，請加QQ群 710574280 我們將為您做出最權威的解答。',
			add: '添加新API',
			fill_info: 'API秘鑰資料填寫',
			role_api: 'API密鑰權限',
			api_check: '查詢資產：查詢賬號信息及資產情況',
			api_trade: '委托交易：委托、取消、查詢交易訂單',
			remarks: '備註',
			remarks_placeholder: '備註API名稱',
			bind_ip: '綁定IP地址（選填）',
			remark_placeholder: '備註API名稱',
			bind_placeholder: '可加多個，用「，」分割',
			create_key: '創建API秘鑰',
			my_key: '我的API秘鑰',
			id: '序號',
			operation: '操作',
			alert_title: 'API秘鑰',
			show_once: '僅顯示一次，若遺忘請重新生成',
			visit_key: 'API訪問秘匙（Access Key）',
			private_key: 'API私有秘匙（Secret Key）',
			copy: '復製',
			important_info: '重要提示：<br>私有秘鑰允許您通過RWAEx開放協議提供API訪問您的賬戶並執行交易指令，' +
				'我們為您提供的秘鑰非常重要，請妥善保管。',
			confirm: '確&nbsp;&nbsp;&nbsp;&nbsp;定',
			delete_api: '刪除',
			delete_confirm: '確定刪除',
			cancel: '取消',
			delete_success: '刪除成功'
		},
		web_record: {
			tabTypeValue1: 'RWA代幣',
			tabTypeValue2: '資金',
			membershipPackage: '會員套餐',
			searchTitle: '賬戶',
			info: '信息',
			transaction: '交易',
			title: '交易記錄',
			recharge: '充幣',
			recharge2: '充值',
			rechargeAddress: '充值地址',
			rechargeTips: '請您在充值時，仔細核對充值信息，避免因信息錯誤導致資產損失',
			rechargeTips1: '請您保證充值數量不小於',
			rechargeTips2: '不大於',
			rechargeTips3: '避免因數量錯誤導致資產損失',
			withdraw: '提幣',
			ctc: '幣幣',
			buy: '買入',
			fiatCurrency: '法幣',
			sell: '賣出',
			other: '其他',
			search: '搜索幣種',
			input_coin: '輸入幣種',
			time: '時間',
			type: '類別-幣種',
			amount: '數量',
			status: '狀態',
			success: '成功',
			fail: '失敗',
			complete: '已完成',
			status_applied: '已申請',
			status_checked: '已審核',
			status_send: '已下發',
			status_confirm: '確認中',
			status_withdraw: '  提現成功',
			status_refused: '已拒絕',
			status_cancel: '已取消',
			recharge_address: '充幣地址',
			withdraw_address: '提幣地址',
			operation: '操作',
			cancel: '取消',
			cancel_success: '取消成功',
			check_detail: '查看詳情',
			account_balance: '賬戶余額',
			wallet_handle_time: '錢包處理時間',
			trade_id: '交易ID',
			desc: '說明',
			fee: '手續費',
			dk: '消耗點卡',
			rebate: '返傭',
			burst_block: '爆快',
			block_detail: '爆塊詳情',
			prize: '中獎金額',
			prize_order: '中獎訂單號',
			prize_tip: '恭喜您參與的爆塊活動成功中獎，獎勵會在24小時內自動發放至您的幣幣賬戶，請註意賬戶余額變化。',
			block_detail_h2: '尊敬的用戶，恭喜您爆塊成功，並瓜分四位獎池'
		}
	},
	burst: {
		header: {
			h1: '每天晚上8點整出爆塊號碼<br>你的訂單號後7位與爆塊號相同，即中大獎！',
			h3: 'RWA交易所首創，爆塊號碼絕對公平公正',
			four_digit: '四位獎池已累計：',
			seven_digit: '七位獎池已累計：',
			nav1: '本期公/私鑰對',
			nav2: '公/私鑰關系驗證',
			nav3: '點擊查看爆塊活動規則'
		},
		q1: {
			title: '1.什麽是爆塊？',
			con: '此玩法為RWA 交易所首創，RWA交易所將拿出手續費收入的30%投入獎池中，' +
				'用戶交易產生的幣幣交易訂單號後4位或7位阿拉伯數字符合當期爆塊號碼的後4位或7位數字的，則爆塊成功。' +
				'根據活動規則瓜分獎池，獎勵將在24小時內自動發放。',
			table_title: 'EOS實時出塊數據',
			time: '出塊時間',
			block_num: '區塊號',
			hash: '哈希值',
			link: '由<a href="https://eospark.com/" target="_blank" style="color: #42CB83;">eospark.com</a>提供數據支持'
		},
		q2: {
			title: '2.如何參與爆塊？',
			con: '總獎池資金為RWA交易所手續費收入的30%，將按20%放入7位獎池，將10%放入4位獎池。 ' +
				'24小時內，用戶在幣幣交易區交易金額滿10USDT的訂單均可參與「爆塊」活動。符合哈希值後4位的用戶瓜分4位獎池資金，' +
				'符合哈希值後7位的用戶瓜分7位獎池資金。',
			trade_now: '立即交易'
		},
		q3: {
			title: '3.獎勵如何發放？',
			con: '每日20:00:00（UTC+8）時自動開獎，獎品會在24小時內發放至用戶的幣幣賬戶，屆時將短信通知中獎用戶。',
			table_title1: '往期開獎信息公示',
			table_title2: '我的有效訂單',
			time: '日期',
			key: '公/私鑰對',
			hash: '哈希值',
			reward: '開獎值',
			publicKey: '公鑰',
			privateKey: '私鑰',
			orderNum: '訂單號',
			status: '狀態',
			rewardMoney: '中獎金額',
			drawn_prize: '中獎',
			drawn_no_prize: '未中獎'
		},
		alert: {
			title_key: '本期公私鑰對',
			publicKey: '公鑰',
			privateKey: '私鑰',
			not_yet_published: '暫未公布（下午20:00:00公布）',
			back: '返&nbsp;&nbsp;&nbsp;&nbsp;回',
			title_rules: '爆塊活動規則',
			rules_con: '選取一對公私鑰對，每日上午8:00:00（UTC+8）對外公布公鑰。<br><br>' +
				'EOSIO主網每秒產出兩個區塊，我們取當日整點20:00:00（UTC+8）生成的兩個區塊，<label style="color: #A0AAC1">' +
				'前一個區塊的後4位數字，後一個區塊的後7位數字，分別與私鑰的最後4位、最後7位數字相加，取最終結果的最後4位、7位數字。' +
				' （如有字母則跳過，如相加結果超過4位、7位，只取相加結果的後4位與後7位。）</label><br><br>' +
				'若用戶的幣幣交易訂單號滿足交易額10USDT，且後4位或後7位與爆塊號碼相同，則瓜分獎池獎金。<br><br>' +
				'<label style="color: #A0AAC1;"> 例，2019年7月2日上午8時公布公鑰：<br>EOS7wW1bAdMqVERBvFShcADXpLhTrs5oWSkzK7vkwosSvrqP5e2nq <br><br>' +
				'下午20時公布區塊哈希值： <br>前：03f9bf71d0e75e131fd75508091c0c64609a3ff9af71be496728e97ef' +
				'<label style="color: #42CB83">953</label>f<label><label style="color: #42CB83">3</label>ba</label>' +
				'<br>後：03f9bf727c3b3be0f9f6c36f8d1bebc0720fe2e65fd4d7f<label style="color: #42CB83">0</label>e<label style="color: #42CB83">88</label>cf' +
				'<label style="color: #42CB83">6</label>bf<label style="color: #42CB83">21</label>d<label style="color: #42CB83">4</label>eebb<br>' +
				'私鑰：5JFyWm2Dx8ywKwEC2bvSUEnZE<label style="color: #42CB83">1</label>rGSCPT<label style="color: #42CB83">18</label>ijAwarJKrp' +
				'<label style="color: #42CB83">579</label>Qe<label style="color: #42CB83">6</label>k<br><br>' +
				'開獎數值為： <br>9533+5796=15329<br>0886214+1185796=2072010<br><br>若用戶訂單號尾數為5329或2072010，則滿足獲獎條件。</label><br><br><br>' +
				'開獎提示：<br>用戶應知悉，公私鑰生成使用的是RSA非對稱加密算法，通過私鑰可導出公鑰，但此推導過程不可逆，因此每產生一個公鑰，' +
				'就一定有其對應的私鑰，且不可更改。<br><br>EOSIO主網每秒產生兩個區塊，區塊哈希值隨機產生，無法被人為控製。' +
				'<br><br>提前公布公鑰，意味著私鑰的不可更換；選取哈希值作為開獎元素，意味著無法人為控製。本活動開獎公平、公正，支持用戶查詢驗證。'
		}
	},
	notification: {
		system: {
			nav: '系統通知',
			login_check: '登錄後可查看',
			mark_all: '全部標記已讀',
			mark_success: '標記成功'
		}
	},
	partner: {
		h1Title1: "加入 RWA 會員計劃",
		h1Title2: "持續拉新返利 & 限時福利活動",
		spanVal: "如何輕鬆賺取返現？",
		spanVal01: '註冊登錄RWA.LTD',
		spanVal02: '使用郵箱註冊登錄',
		spanVal03: '購買會員套餐成為會員',
		spanVal04: '支付100USD/782HKD/100USDT',
		spanVal05: '獲取並分享邀請鏈接',
		spanVal06: '邀請您的好友進行註冊',
		spanVal07: '獲取交易返傭',
		spanVal08: '好友完成任一交易獲得返傭',
		becomeMember: '成為會員',
		memberTips: '您還不是會員，購買 100USD 點卡成為交易所會員，享會員權益',
		memberTips1: '立即成為平臺會員',
		memberTips2: '邀請更多好友，赚取更多獎勵',
		memberTips3: '邀請更多好友，赚取更多獎勵',
		memberTips4: '您即將購買會員套餐，購買會員套餐後將享受會員權益，請先確認現貨賬戶余額充足',
		memberTips5: 'RWA.LTD會員套餐',
		memberTips6: '成為交易所會員，贏40%交易返傭獎勵',
		memberTips7: '恭喜您成為會員',
		memberTips8: '立刻邀請好友，贏取交易返傭！',
		memberTips9: '您已成为平台会员',
		memberWorth: '價值',
		memberPay: '需支付',
		memberNowPay: '立即支付',
		memberVip: '等級',
		shareList: '邀請數據',
		shareListTips: '實時發放邀請好友開通會員的獎勵，直接發放至 USD 資產錢包中，敬請留意查收。',
		rebateRatio: '返傭比例',
		cumulativeRebate: '累計返傭',
		cumulativeCashback: '累計返現',
		cumulativeCashback1: '累計邀請(直邀)人數',
		shareTab1: '邀請排行',
		shareTab2: '邀請記錄',
		shareTab3: '返傭記錄',
		questionsTitle: '常見問題',
		questionsVal1: '是否存在返佣上限？',
		questionsVal2: '是的。出於合規考量，RWA.LTD 為每位會員設定了每月 1000USD 的返佣及現金返還總額上限。',
		questionsVal3: ' 成為會員後，如何獲得邀請返佣？',
		questionsVal4: 'A 邀請好友 B 在交易所註冊。當 B 在交易所進行交易時，A 可獲得 40% 的交易手續費返佣。若 B 再邀請 C 註冊，當 C 進行交易時，B 可獲得 40% 的交易手續費返佣，同時 A 可獲得 10% 的交易手續費返佣。',
		questionsVal5: ' 成為會員後，如何獲得交易現金返還 (cashback)?',
		questionsVal6: ' 若 A 邀請的好友 B 成為交易所會員，A 可獲得 20USD/USDT 的現金返還。若 B 再邀請 C 成為交易所會員，則 B 可獲得 20USD/USDT 的現金返還，而 A 可獲得 10USD/USDT 的現金返還。',
		questionsVal61: ' 會員計劃是否有時間限制？',
		questionsVal62: ' 截至目前，該計劃未設定時間限制。但 RWA.LTD 保留隨時自行決定對該計劃進行修改、暫停或終止的權利，且無需事先通知。',
		questionsVal7: ' 成為會員後有哪些權益？',
		questionsVal8: ' 成為會員後，您將享有以下權益：',
		questionsVal81: '1. 推薦返現：下級好友購買會員套餐後，您可獲得返現獎勵。',
		questionsVal82: '2. 交易手續費折扣：自購買日起，365 天內平台交易手續費可享受 5 折優惠。',
		questionsVal83: '3.100USD 會員費可抵扣 50% 的手續費，在抵扣期間，由於會員享有 5 折手續費優惠，需再支付的手續費僅為初始費用的 25%。',
		header_con1: '與用戶共享平臺福利',
		header_con2: '百萬富翁合夥人計劃',
		header_con3: '會員招募中',
		not_login: '您還未登陸',
		please_login: '請先登錄',
		need_set_password: '需要設置交易密碼',
		set_now: '去設置',
		not_yet_member: '您還不是會員',
		not_yet_partner: '您還不是合夥人',
		update_now: '立即升級',
		is_vip: '您好，您目前的等級為',
		my_reward: '我的收益折合(USDT)',
		rwa_register: '註冊用戶',
		rwa_member: 'RWA會員',
		rwa_partner: 'RWA合夥人',
		rwa_diamond: 'RWA鉆石合夥人',
		create_poster: '生成海報',
		my_invite_code: '我的邀請碼',
		share_invite_code: '分享邀請鏈接',
		my_invite_code_url: '我的邀請碼鏈接',
		copy_success: '復製成功',
		copy_fail: '復製失敗',
		invite_reward_withdraw: '點卡返現',
		second_invite_reward_withdraw: '二級點卡返現',
		invite_reward_fee: '交易返傭比例',
		second_invite_reward_fee: '二級交易返傭比例',
		invite_amount: '邀請人數',
		invite_up_member: '我的一級會員',
		invite_upup_member: '我的二級會員',
		volume_24h: '24H交易筆數',
		reward_withdraw_24h: '24H已返傭',
		reward_fee_total: '我的交易返傭',
		reward_withdraw_total: '我的邀請返現',
		reward_cash_total: '返現金額',
		title1: '1. 什麽是會員製交易所？',
		table_title1: 'RWA交易所會員權益及返傭規則',
		table_title2: 'RWA交易所各級會員要求',
		dk_reward: '點卡返現',
		trans_reward_fee: '交易返傭',
		up_trans_reward_fee: '二級交易返傭',
		level: '等級',
		up_dk_reward: '二級點卡返現',
		fee_discount: '手續費折扣',
		need: '需要',
		no_need: '不需要',
		real_name: '實名認證',
		buy_dk: '購買點卡',
		need_invite_amount: '邀請人數要求',
		need_trans_money: '交易金額要求',
		con1: 'RWA交易所的會員可以享受平臺的諸多權益，而平臺的定位是交易所技術服務方，平臺將交易所利潤讓渡給會員，讓會員享受更多的收益，成為交易所的「老板」。 <br>' +
			'RWA平臺通過會員製吸引優質用戶加入社區，采用社區共建、讓利會員的方式打造強大的RWA社區，進一步打造全球第一會員製交易所。',
		example1: '例：<br><p style="color: #222A55; font-size: 16px;">1）A是RWA交易所的註冊用戶，那麽A怎麽成為交易所會員呢？</p>' +
			'A想成為交易所會員，只需要直接購買100USDT點卡，就可以成為交易所會員了。' +
			'<p style="margin-top: 30px;color: #222A55; font-size: 16px;">2）成為會員後，A怎麽獲得邀請返傭？</p>' +
			'A邀請好友B註冊RWA交易所，B在交易所交易時，A可以獲得40%交易手續費的返傭<br>' +
			'B又邀請了C註冊，C在交易時，B可以獲得40%交易手續費返傭，A可以獲得10%交易手續費返傭。' +
			'<p style="margin-top: 30px;color: #222A55; font-size: 16px;">3）成為會員後，A怎麽獲得交易返現？</p>' +
			'如果A邀請的好友B也成為了交易所會員，A可以獲得20USDT返現<br>' +
			'如果B邀請的C也成為交易所會員，那麽B可以獲得20USDT返現，A可以獲得10USDT返現。',
		title2: '2. 如何成為交易所會員和更高級的合夥人？',
		con2: '用戶購買100USDT點卡成為RWA平臺會員後，' +
			'只要滿足邀請會員人數要求、交易金額要求這兩項指標後，即可自動升級成為更高級的合夥人。',
		example2: '例：<br><p style="color: #222A55; font-size: 16px;">1）A已經是交易所會員了，那麽如何升級成為合夥人呢？</p>' +
			'A直推邀請至少2名會員（包含會員以上身份），並且在RWA平臺交易額滿10000USDT（包含Taker與Maker），即可成為RWA合夥人；<br>' +
			'A直推邀請至少5名會員（包含會員以上身份），並且在RWA平臺交易額滿50000USDT（包含Taker與Maker），即可成為RWA鉆石合夥人；<br>' +
			'<p style="margin-top: 30px">會員是指購買100USDT點卡的用戶。</p>',
		example2_2: '<p style="color: #222A55; font-size: 16px;">2）我已經是會員，可以購買會員權益贈送他人嗎？</p>' +
			'在您已經是會員的前提下，可以通過購買會員權益，生成指定的會員邀請碼，幫助他人一鍵註冊成為會員。<br>' +
			'當對方使用您的會員權益邀請碼註冊成功後，即可一步成為會員身份，無需經過其他步驟。 <br>' +
			'每個會員權益邀請碼僅可使用一次，註冊成功即失效。',
		btn_be_member: '立即成為交易所會員',
		btn_detail: '會員權益詳解',
		btn_gift: '購買會員權益卡贈與他人',
		btn_check: '查看會員權益卡使用情況',
		title3: '3.返傭如何發放？',
		con3: '每天08：00:00 (GMT+0800) 將返還前24小時邀請邀請獎勵，直接發放到幣幣賬戶，請註意查收。',
		reward_cash_rank: '返現排行榜',
		invite_record: '我的邀請記錄',
		reward_record: '我的返傭記錄',
		rank: '排名',
		partner_lvl: '合夥人等級',
		user: '用戶',
		time: '時間',
		user_invited: '受邀人',
		reward_cash_amount: '返現金額',
		reward_fee_money: '返傭金額',
		btn_alert: '開始我的特權之旅',
		buy_card: '購買會員權益卡',
		pay_after: '付款後顯示邀請碼',
		create_invite_code: '生成邀請碼',
		assign_user: '指定用戶',
		pay_con: '您即將購買會員權益卡，購買會員權益卡後可以贈與他人，請先確認幣幣賬戶余額充足',
		should_pay: '應付金額',
		trade_password_placeholder: '請輸入交易密碼',
		uid_placeholder: '請輸入用戶UID',
		uid_error: '非法UID',
		check: '校驗',
		not_check: '請先進行身份校驗',
		check_fail: 'UID校驗失敗，無法為其購買會員',
		is_follow_me: '此用戶為您的直邀用戶',
		not_follow_me: '此用戶不是您的直邀用戶，請謹慎購買',
		pay_confirm: '確認支付',
		be_member: '已經成為會員',
		cancel: '取消',
		buy_complete: '購買完成',
		click_copy: '點擊復製',
		success_con: '當他人使用您的邀請碼進行註冊時，即可一步成為會員身份。每個邀請碼僅可使用一次，註冊成功即失效',
		close: '關閉',
		has_buy_card: '已購買的權益卡',
		buy_time: '購買時間',
		invite_code: '邀請碼',
		direct: '直升',
		status: '狀態',
		status_0: '未認證',
		status_1: '已認證',
		status_2: '審核中',
		status_3: '審核失敗',
		code_user: '使用人',
		operation: '操作',
		copy: '復製',
		not_use: '未使用',
		invalid: '已失效',
		must_member: '只有會員才可以購買權益卡',
		activity: {
			title: "會員權益",
			content1: "持續拉新返利",
			content2: "1. 交易手續費返佣：會員 A（「推薦人」）邀請會員 B（「被推薦人」）在 RWA.LTD 註冊。當會員 B 進行交易時，會員 A 可獲得 B 交易手續費的 40% 返佣。若會員 B 進一步推薦會員 C，則：",
			content2$1: " - 會員B可獲得C交易手續費的 40% 返佣；",
			content2$2: "- 會員 A 可獲得 C 交易手續費的 10% 返佣。",
			content2$2$0: "2. 推薦獎勵：會員 A 推薦會員 B 在 RWA.LTD 註冊後，會員 A 可在 B 成功註冊後獲得 20 美元（或等值 USDT）註冊獎勵。若會員 B 進一步推薦會員 C，則：",
			content2$2$1: "- 會員 B 可獲得 20 美元（或等值 USDT）註冊獎勵；",
			content2$2$2: "- 會員 A 可獲得 10 美元（或等值 USDT）二級推薦獎勵。",
			content3: "限時福利活動",
			content3$0: "1. 空投禮包：價值100美元的優質消費資產代幣【活動時間：2026年3月19日 – 2026年4月19日】",
			content3$1: "- 空投內容：150 RWA + 300 DIMD + 300 GCT + 300 TOP100",
			content3$2: "- 發放規則：每週日統計會員數據，並按順序發放資產禮包；所有資產將在 三個月內全部發放完成。",
			content3$2$0: "2. 五折交易手續費優惠【有效期：1 年】",
			content3$2$1: "- 手續費折扣：會員在一年內享受所有交易對 50% 的交易手續費折扣 —— 交易越多，節省越多。",
			content3$2$2: "- 會員費抵扣機制：已支付的價值 100 美元會員費可用於抵扣最多 50% 的交易手續費。在抵扣期間，疊加 50% 手續費折扣後，會員實際支付的手續費僅為原始手續費的 25%。",
			
			content4: "2026年3月19日至2026年3月20日",
			content5: "三、活動福利",
			content6: "福利 1：價值100USD的平台優質資產大禮包空投",
			content7: "活動期間新開通會員，額外獲贈總價值 100 USD 的優質消費品RWA資產組合大禮包。",
			content8: "空投內容：150 RWA + 300 DIMD + 300 GCT + 300 TOP100",
			content9: "發放規則：每周日統計會員數據，依次空投一種資產禮包，全部資產禮包將于3個月內全部發放完畢。",
			content10: "福利 2：年度會員專屬權益",
			content11: "手續費5折：1年內所有交易對手續費享受 5折 優惠，交易越多，節省越多。",
			content12: "會員費抵扣手續費：您支付的100USD會員費，可直接用于抵扣未來產生交易手續費的50%，相當于在交易手續費5折基礎上再享5折優惠。",
			content13: "福利 3：邀請推介，立享返現",
			content14: "直推獎勵：直接邀請好友開通會員，您可獲得 20USD/USDT 返現。",
			content15: "間推獎勵：好友再邀請他人，您還可獲得 10USD/USDT 返現。"
		}
	},
	about: {
		title: '關於我們',
		titleInfo: 'RWA.LTD 是由香港國際新經濟研究院 (INERI) 透過其全資子公司 RWAGroup Limited 打造的全球首家專注於非金融現實世界資產 (RealWorld Assets,RWA) 代幣的交易平台，在香港法規下以「有限用途數碼代幣 (Limited Purpose Digital Token)」交易平台之身份合規運營。',
		titleInfo1: ' 香港國際新經濟研究院 (INERI) 由 CEO 付饒先生於 2019 年創立，是香港科技園 (HongKong Science and Technology Parks) 的孵化企業之一，並獲香港特區政府多項津貼支持。成立初期，INERI 的核心業務為區塊鏈賦能產業諮詢。付饒先生亦長期參與高校教學與研究工作，曾任香港大學、香港城市大學、香港中文大學 (深圳) 及北京大學的客座講師。自 2023 年起，INERI 開始重點佈局非金融類 RWA 的代幣化應用，其創立的 NFT China 平台與比亞迪 (BYDDY) 等知名企業達成合作，主導並推動多個非金融類 NFT 項目的發行，平台上線三個月內註冊用戶即突破 30 萬。',
		titleInfo2: ' 基於豐富的 NFT 平台運營經驗及產業資源，INERI 自 2024 年年末起啟動非金融同質化代幣 (FT) 平台的籌備工作。RWALTD 平台於 2025 年 9 月中旬正式上線，成為全球首個專注於有限用途數碼代幣交易的平台，致力於透過區塊鏈技術實現非金融權益的數位化表達與流通。2026 年 3 月，RWA.LTD 完成首次平台升級與系統改版，進一步提升平台的安全性、穩定性與用戶體驗，持續推動非金融 RWA 代幣化生態的發展。'
	},
	footerAddress: {
		btnVal1: '搜索',
		btnVal2: '清除',
		btnVal3: '電話',
		inputPlaceholder: '請輸入地點名稱'
	},
	download: {
		title: 'RWA應用下載',
		title1: '鏈商平臺 重磅來襲',
		title2: '代幣機製和商品經濟的創新性結合，為您帶來全新體驗',
		h3: '安全、穩定、高效的',
		h1: '數字資產交易平臺',
		ios: 'IOS下載',
		android: 'Android下載'
	},
	financial: {
		home: {
			header: 'RWAEx 理財寶',
			tip: '是一個區塊鏈資產持幣生息，穩定型收益投資平臺，包括定期（鎖倉理財），活期理財等多種類型的產品，為穩健型投資用戶提供最佳投資渠道',
			my_had: '我的持幣',
			ongoing: '正在進行',
			mining: '挖礦中',
			tobe_started: '即將開始',
			end: '已經結束',
			rate_year: '參考年化',
			auto: '靈活',
			buy_min: '起購',
			mine_min: '起挖',
			assign_coin: '利息幣種',
			to_end_time: '距離搶購結束',
			left_position: '剩余倉位',
			lock_position: '已鎖倉位',
			day: '天',
			hour: '時',
			minutes: '分',
			seconds: '秒',
			after_start: '後開始',
		}
	},
	footerPrivacy: {
		title: '隱私聲明',
		titleInfo: '本隱私聲明由 RWA Group（下稱「我們」或「本公司」；「RWA Group的」為「我們的」）向您作為本平臺[RWA.LTD]、網站[https://www.rwahk.ltd/]以及任何相關的電腦或移動應用程序的訪客或用戶作出。RWAGroup 指 RWA GroupLimited（一家在香港註冊成立的有限公司，商業登記號碼為74645397）。本聲明是根據《個人資料（私隱）條例》（「《私隱條例》」）而製定。',
		titleInfo1: '第一部分：個人資料收集聲明（PICS）',
		titleInfo2: 'A. 收集目的',
		titleInfo3: '我們收集和儲存您的個人資料，以提供和優化我們的服務，包括但不限於：',
		titleInfo4: '(a)創建和管理您的用戶賬戶;',
		titleInfo5: '(b)根據反洗錢（AML）及打擊恐怖分子資金籌集（CFT）規定核實您的身份;',
		titleInfo6: '(c)處理您的交易（包括充值、提現及交易）;',
		titleInfo7: '(d)發送行政通知及（在允許的情況下）市場推廣信息;',
		titleInfo8: '(e)遵守適用的法律義務或監管要求。',
		titleInfo9: 'B. 收集的個人資料類別',
		titleInfo10: '我們可能收集的個人資料包括：',
		titleInfo11: '(a) 身份識別資料（例如：姓名、香港身份證/護照號碼）;',
		titleInfo12: '(b) 聯絡資料（例如：電郵地址、電話號碼、住址）;',
		titleInfo13: '(c) 財務及交易資料（例如：錢包地址、交易記錄、銀行賬戶信息）;',
		titleInfo14: '(d) 設備及使用數據（例如：IP 地址、瀏覽器類型、Cookies）。',
		titleInfo15: 'C. 不提供資料的後果',
		titleInfo16: '提供個人資料一般為自願性質。然而，某些資料為使用本服務所必須提供。如您未能提供該等資料，我們可能無法向您提供產品或服務，包括但不限於：',
		titleInfo17: '(a) 開立或維持您的賬戶;',
		titleInfo18: '(b) 處理您的交易;',
		titleInfo19: '(c) 遵守法律或監管要求。',
		titleInfo20: 'D. 資料披露對象類別',
		titleInfo21: '我們可能會將您的個人資料披露予以下類別的人員：',
		titleInfo22: '(a) 我們的關聯公司及服務供應商（例如：KYC 服務提供商、支付處理機構）;',
		titleInfo23: '(b) 法律要求下的政府機關、監管機構或執法機構;',
		titleInfo24: '(c) 負有保密責任的法律、財務或專業顧問。',
		titleInfo25: 'E. 直接促銷',
		titleInfo26: '我們可能會使用您的姓名、手機號碼、電郵地址及住址，向您發送有關我們服務和產品的市場推廣信息。除非我們已獲得您的同意或您未表示反對，否則我們不會使用您的個人資料作直接促銷用途。您可隨時通過 [s@rwa.ltd] 聯系我們，選擇退出接收市場推廣信息。',
		titleInfo27: 'F. 查閱及改正權利',
		titleInfo28: '您有權根據《私隱條例》查閱及要求改正我們所持有的您的個人資料。有關申請請以書面形式發送至 [s@rwa.ltd]。',
		titleInfo29: '第二部分：私隱政策聲明（PPS）',
		titleInfo30: 'A. 所持個人資料種類',
		titleInfo31: '我們保存的個人資料種類包括：',
		titleInfo32: '(a) 用戶註冊及身份識別資料;',
		titleInfo33: '(b) 交易及活動記錄;',
		titleInfo34: '(c) 與用戶的通訊記錄',
		titleInfo35: '(d) Cookies 及技術使用數據。',
		titleInfo36: 'B. 使用的主要目的',
		titleInfo37: '個人資料的使用目的與上述 PICS 中列明的目的相同。',
		titleInfo38: 'C. 資料保存',
		titleInfo39: '我們僅在為達成本資料收集目的所需的期間內或依照法律要求（例如：AML/CFT 規定）保留您的個人資料。相關期限屆滿後，該資料將被安全刪除或匿名化處理。盡管有上述規定，您已在《平臺使用協議》中同意我們可保存特定信息長達六（6）年。',
		titleInfo40: 'D. 安全措施',
		titleInfo41: '我們采取適當的技術和組織措施，保障您的個人資料免遭未授權的訪問、處理、刪除或丟失。',
		titleInfo42: 'E. 查閱及改正資料',
		titleInfo43: '本部分內容與上文 PICS 中所列相同。',
		titleInfo44: 'F. Cookies 的使用',
		titleInfo45: '我們可能會使用 Cookies 或類似技術來提升用戶體驗及分析網站流量。您可通過瀏覽器設置禁用 Cookies，但這可能影響某些功能的正常使用。',
		titleInfo46: '更新日期：[2025/8/8]',
		titleInfo47: '聯系方式：[s@rwa.ltd]',
	},
	footerAgreement: {
		title: '平臺使用協議',
		titleTime: '最後更新：2025年8月28日',
		titleInfo1: '如果您未完全理解並接受以下內容，您不應購買、持有、消費或轉移平臺流通代幣。',
		titleInfo2: '本平臺使用協議中的所有內容（以下簡稱「本協議」）構成您與RWA Group（以下簡稱「我們」）之間的具有法律約束力的協議。RWA Group包括 RWAGroup Limited（一家在香港註冊成立的有限公司；商業登記號碼為74645397）、其任何關聯主體、前述主體的所有雇員、外部服務承包商以及外部顧問。本協議適用於您與我們之間的相關法律關系，包括但不限於您在',
		titleInfo3: '平臺RWA.LTD、網站【https://rwa.ltd】以及其他關聯計算機端或手機端應用程序',
		titleInfo4: '（以下合稱「平臺」）購買、持有、消費或轉移的在平臺上流通的任何代幣（以下簡稱「平臺流通代幣」）而產生的法律關系。訪問或使用平臺、註冊平臺賬戶、購買、持有、消費或轉移平臺流通代幣、或從事其他與平臺相關或基於平臺的活動（以下合稱「平臺活動」或「活動」），您承認並同意您將遵守本協議。如果您就任何平臺流通代幣進行平臺活動，您承認並同意您將遵守專門為該代幣所代表的商品或服務所製定的協議，該協議可能以多種形式展現在平臺，包括但不限於代幣白皮書（以下簡稱「產品協議」）。您進一步承認並同意，基於商業合理性，我們能夠單方面地、不時地且沒有特別事先通知的情況下更新或修改所有上述協議，並且您應該在進行任何平臺活動前，閱讀並理解這些協議的最新版本以及其中引用的任何補充文件。',
		titleInfo5: '風險提示和同意',
		titleInfo6: '未免疑問，風險提示部分屬於本協議不可分割的一部分，與其他部分具有同等法律效力。在做出任何與平臺流通代幣相關的決定或進行任何交易之前，您應采取一切合理措施確保已充分理解該交易，並獨立評估其適當性和風險。在做出與平臺流通代幣相關的任何決定之前，您應確保您擁有充分的信息。如果您對平臺流通代幣、平臺活動或本協議的任何內容有疑問，您應獲得獨立的專業意見。RWA Group已確定平臺流通代幣為香港《打擊洗錢及恐怖分子資金籌集條例》（「AMLO」）第53ZR條定義的「有限用途數碼代幣」，即客戶酬報或獎賞積分；遊戲用資產；或任何符合以下說明的數碼形式價值——(i)類似客戶酬報或獎賞積分或遊戲用資產；且(ii)按其發行人的用意，該數碼形式價值不可轉換為金錢或獲得公眾接受的另一交易媒介。因此，根據AMLO第53ZRA，平臺流通代幣不屬於AMLO項下的「虛擬資產」，「VA」或「VirtualAsset」。平臺流通代幣並非作為證券或任何其他形式的投資產品進行結構化或銷售。平臺流通代幣未經過任何監管機構審查、備案或授權。RWAGroup未進行、也不打算在任何相關法律禁止的司法管轄區進行與平臺流通代幣相關的任何活動。您應確保與平臺流通代幣相關的所有活動在適用司法管轄區內系合法的。',
		titleInfo7: '您在此承認您理解並承擔多種風險（包括但不限於以下風險）及因這些風險而導致的所有損失：',
		titleInfo8: 'A. 與區塊鏈技術和網絡安全相關的風險',
		titleInfo9: '由於平臺流通代幣基於區塊鏈技術，任何相關區塊鏈的故障、崩潰或放棄可能會對平臺流通代幣產生重大不利影響。此外，密碼學的進展或量子計算等技術進步可能會通過使基礎區塊鏈的密碼學共識機製失效，從而對平臺流通代幣構成風險。與其他基於區塊鏈技術的去中心化加密代幣一樣，平臺流通代幣容易受到節點或驗證者的攻擊，這些節點或驗證者負責驗證/確認平臺流通代幣在相關區塊鏈上的交易。任何成功的攻擊都可能對平臺流通代幣構成風險。黑客或其他惡意團體或組織可能會以多種方式幹擾平臺流通代幣，包括但不限於惡意軟件攻擊、拒絕服務攻擊、共識攻擊、Sybil攻擊、變相攻擊和欺騙攻擊。',
		titleInfo10: 'B. 與平臺流通代幣流動性不足相關的風險',
		titleInfo11: '平臺流通代幣沒有業已存在的市場，平臺流通代幣的銷售可能不會導致一個活躍或流動的市場。持有者可能面臨平臺流通代幣的流動性風險。RWA Group不負責平臺流通代幣在任何市場上的流通和交易。無任何主體有義務從任何平臺流通代幣持有者處購買平臺流通代幣，也冇任何主體保證平臺流通代幣的流動性或市場價格。RWAGroup因此不得確保平臺流通代幣會有任何需求或市場。RWAGroup擁有出於各類考慮（例如法律、政策或執法變化等）而調整、限製或暫停平臺流通代幣的流動性和任何其他活動的權利，且不就此類調整、限製和暫停承擔任何責任。',
		titleInfo12: 'C. 與價格波動相關的風險',
		titleInfo13: '平臺流通代幣的價格通常可能會因特定底層資產市場（例如相關知識產權、產品或服務等）等外部因素而相對波動，且在短期內可能會有較大波動。單一代表性區塊鏈資產價格的下降可能會導致對區塊鏈行業的信心不足，即使該資產與平臺流通代幣無關，其價格下跌亦可能導致整個區塊鏈行業信心受挫，從而影響平臺流通代幣的市場。平臺流通代幣交易的實時價格面臨實質性風險，並可能因市場條件和其他超出RWA Group控製的因素而大幅波動。',
		titleInfo14: 'D. 與不確定的監管限製相關的風險',
		titleInfo15: '除平臺官方特別說明，平臺流通代幣未在香港AMLO項下的任何持牌虛擬資產交易平臺上市，也不能保證將來會在前述平臺上市交易。重要的是，盡管平臺流通代幣被設計和構建為「有限用途數字代幣」或無任何投資屬性的用益代幣，而絕不作為《AMLO》第53ZRA條定義的「虛擬資產」或證券或其他投資產品，但是由於法律規則、執法態度或環境的變化，或由於RWA Group無法控製的其他原因，RWA Group有全權酌情調整、限製或暫停與平臺流通代幣相關的任何活動，對此RWA Group不承擔任何賠償責任。 如果您打算就平臺流通代幣采取任何（直接或間接）行動，您將負責遵守所有適用法律、法規和規則，並提供所有適當的風險提示和披露。',
		titleInfo16: 'E. 不可預見的風險',
		titleInfo17: '像平臺流通代幣這樣的加密代幣是一項新型且未經測試的技術。除上述風險外，購買、持有、消費、轉移及其他平臺流通代幣活動可能會涉及RWA Group無法預見或合理控製的其他風險。這些風險可能會以不可預見的方式或組合形式顯現。',
		titleInfo18: 'F. 平臺政策變化的風險',
		titleInfo19: 'RWA Group基於（i）其認為的合法商業考慮、（ii）對現行法律和政策的理解或（iii）對法律和政策趨勢的理解，保留隨時更改平臺流通代幣、平臺活動、本協議和任何產品協議的性質和內容（包括但不限於其供應和分配計劃、政策和機製等）的權利。在做出任何與平臺流通代幣相關的決定之前，您應確保已仔細閱讀並完全理解彼時平臺上最新版本的本協議和已更新的其他相關內容。',
		titleInfo20: '1. 賬戶。',
		titleInfo21: '1.1註冊。',
		titleInfo22: '您需要在平臺註冊賬戶，以確保您根據本協議享有的任何權利。然而，未註冊或登錄賬戶不會影響本協議作為有效協議在適用法律下對您和我們具有約束力。開設賬戶即表示您同意僅為自己使用該賬戶，任何第三方使用您的賬戶需要獲得我們的書面同意。您對賬戶進行的所有活動及由此產生的法律後果承擔全部責任。',
		titleInfo23: '1.2 限製措施。',
		titleInfo24: '平臺有權在下列情形中，單方面采取賬戶凍結、交易限製和/或資產鎖定等限製措施，無需事先通知用戶：',
		titleInfo25: 'a. 接到司法機關、監管機構或有管轄權的其他機構的指示;',
		titleInfo26: 'b. 發現或合理懷疑賬戶存在異常交易、涉嫌洗錢、詐騙、非法集資、操縱市場、網絡攻擊或其他違法行為；',
		titleInfo27: 'c. 發現或合理懷疑賬戶違反本協議或平臺其他規則；或',
		titleInfo28: 'd. 平臺合理認為，為保障其他用戶、平臺或公共利益有必要對某些賬戶采取的任何限製措施。',
		titleInfo29: '平臺采取凍結措施後，用戶可按照平臺要求提交相關資料申請解除凍結。平臺有權根據自身判斷決定是否解除凍結，並保留最終決定權。',
		titleInfo30: '1.3 用戶自願註銷。',
		titleInfo31: '用戶可透過平臺提供的流程申請註銷其賬戶。註銷賬戶須符合以下條件：',
		titleInfo32: 'a. 賬戶內無未了結的交易或糾紛；',
		titleInfo33: 'b. 賬戶內無剩余資產；',
		titleInfo34: 'c. 未處於司法調查、監管審查或平臺風控限製狀態',
		titleInfo35: '賬戶一旦註銷，將無法恢復；相關數據將依據適用法律法規及平臺隱私政策予以處理。',
		titleInfo36: '1.4平臺終止賬戶。',
		titleInfo37: '若平臺合理判斷存在下列情形之一，平臺有權單方面終止賬戶並回收使用權，無須取得用戶同意：',
		titleInfo38: 'a. 賬戶違反本協議或相關法律，或存在重大合規風險；',
		titleInfo39: 'b. 賬戶連續三年內未進行任何平臺活動，平臺視為用戶已放棄賬戶；',
		titleInfo40: 'c. 賬戶身份信息虛假、冒名頂替、重復註冊等；',
		titleInfo41: 'd. 賬戶從事任何損害平臺利益、聲譽或安全的行為；',
		titleInfo42: 'e. 其他平臺認定需回收賬戶的合理事由。',
		titleInfo43: '平臺終止賬戶後，視情況決定是否退還賬戶內剩余合法資產，若賬戶存在違法行為或損害平臺利益的其他行為，平臺有權抵扣相關損失後再行退還。',
		titleInfo44: '2. 信息和通信',
		titleInfo45: '2.1 身份驗證。',
		titleInfo46: '您需在開設賬戶之前遵循我們的身份驗證程序，通過向我們提供有關您的某些信息，以及在相關情況下提供任何被許可的第三方用戶的信息。您提供的所有信息必須完整、準確且真實。若信息發生變更，您必須更新該信息。',
		titleInfo47: '您授權我們直接或通過第三方進行我們認為必要的查詢，以驗證您的身份及任何被許可的第三方用戶的身份，以保護您和/或我們免受欺詐、洗錢、恐怖主義融資或其他犯罪行為的風險，並根據查詢結果采取我們認為必要的措施。',
		titleInfo48: '當我們進行查詢時，您承認並同意，您的個人信息以及任何被許可的第三方用戶的信息可能會被披露給身份驗證、合規性數據記錄、信用參考、欺詐防範或金融犯罪機構，這些機構可能會對我們的查詢作出完整回應。',
		titleInfo49: '2.2 強化盡職調查。',
		titleInfo50: '我們可能要求您通過提交有關您、您的業務或任何被許可的第三方用戶的附加信息、提供額外記錄或文檔，或與RWA Group的授權代表進行面對面會議來遵循我們的強化盡職調查程序。',
		titleInfo51: '2.3 信息請求',
		titleInfo52: '為了遵守任何適用法律、身份驗證要求、檢測洗錢、恐怖主義融資、欺詐或任何其他犯罪，或其他有效理由，我們可能隨時要求您提供信息。您同意提供我們要求的相關信息，並授權我們保留這些信息記錄最長六（6）年。',
		titleInfo53: '2.4 通過註冊電子郵件的通信。',
		titleInfo54: '您承認有義務檢查您的電子郵件，包括垃圾郵件。RWA Group單方面發送的信息自發送後即視為有效傳達至您。自發送後的七（7）個工作日內未作回應或采取行動將視為您無異議並同意RWA Group在該電子郵件中所表述的內容。',
		titleInfo55: '我們可以通過電子郵件向您的註冊郵箱發出具有法律效力或後果的通知或其他通知。您有責任確保電子郵件地址是最新和準確的。通知一經發送至您提供的電子郵件地址，即視為已送達。若因您未及時更新電子郵件地址或未及時查閱郵件導致任何法律後果，由您獨自承擔。您僅能按照我們不時指示的方式向我們發送通知。',
		titleInfo56: '2.5 公告。',
		titleInfo57: '所有官方公告，包括但不限於促銷、競賽和空投等公告，將列出在平臺上。這些公告很重要，可能與您對平臺流通代幣的活動決策有關。您有責任定期訪問平臺查閱相關公告，無論這些公告在您相應行為前或後發出。因未及時查閱公告導致的任何法律後果，由您獨自承擔。',
		titleInfo58: '2.6 錄製。',
		titleInfo59: '您同意我們可以錄製與您之間通過任何形式（包括但不限於電子通信、電話或面對面交流）進行的通信，並確認這些錄音可作為雙方通信的有效證據。您同意電話通話可能會在沒有使用提示音或其他進一步通知的情況下進行錄製。',
		titleInfo60: '3.  禁止活動。如用戶或被平臺合理懷疑進行以下禁止活動，平臺有權立即采取包括但不限於限製交易、凍結賬戶、終止賬戶、回收代幣及終止服務等措施，並保留依法追究責任的權利。在不影響本協議中任何其他限製或約束的情況下，您同意您和任何第三方用戶不會：',
		titleInfo61: 'a. 違反本協議或根據本協議及相關本協議（包括但不限於任何產品協議）達成的任何協議；',
		titleInfo62: 'b. 從事任何以投資為目的的平臺流通代幣活動，將平臺流通代幣視為任何投資產品；以任何有意或客觀上使平臺流通代幣被視為投資產品的方式行事；或從事任何活動增大平臺流通代幣被任何司法管轄區監管機構視為投資產品的風險；',
		titleInfo63: 'c. 對第三人或公開作出關於我們的任何虛假的',
		titleInfo64: '不利、批評或貶損',
		titleInfo65: '的言論、指控或評論（無論是明示還是暗示），除非該言論基於客觀事實並已獲得有效判決或裁定支持；',
		titleInfo66: 'd. 以違反公共利益、公共道德或他人合法利益的方式在平臺上從事活動；',
		titleInfo67: 'e. 從事市場操縱行為（如拉高出貨、對倒交易、自買自賣、前置交易、報價填充、欺騙或分層操作等），無論是否被適用法律禁止；',
		titleInfo68: 'f. 從事欺詐活動，或使我們懷疑您或任何許可用戶從事欺詐活動和/或交易；',
		titleInfo69: 'g. 使用平臺流通代幣進行或參與非由我們舉辦監督的彩票、賭博活動、拍賣費用競標、體育預測或賠率製定、現金獎品的虛擬體育聯賽、網絡遊戲、競賽、抽獎或任何機會遊戲；',
		titleInfo70: 'h. 提供虛假、不準確或誤導性的信息，這些信息與您在平臺流通代幣上的活動、與我們的通信或與本協議相關的其他事項相關；',
		titleInfo71: 'i. 修改或適應平臺的全部或任何部分，或將平臺合並或整合到其他程序或應用中；',
		titleInfo72: 'j. 修改、復製、重復、下載、存儲、傳輸、傳播、轉讓、拆解、廣播、發布、刪除或更改任何版權聲明或標簽，或許可、轉許可、銷售、鏡像、設計、租賃、出售、私有化、授予該知識產權的擔保權益或知識產權的任何部分，或創作衍生作品，或以任何方式利用任何部分的知識產權牟利；',
		titleInfo73: 'k. 違反或試圖違反（i）任何適用的法律，（ii）我們或任何第三方的版權、專利、商標、商業秘密或其他知識產權，或（iii）公眾權益或隱私權。',
		titleInfo74: '4. 實質利益和利益沖突',
		titleInfo75: '4.1 實質利益。',
		titleInfo76: '您理解並同意，RWA Group無義務向您披露或使用任何其知悉的信息為您謀取利益，且不對因未披露或使用而產生的任何後果承擔責任。',
		titleInfo77: '您進一步確認，我們可能不時收到任何關於平臺流通代幣或平臺活動的信息，這些信息可能會影響代幣的價格或流通性。我們可能將前述信息合法用於我們自身的活動或利益。',
		titleInfo78: '4.2 RWA Group的活動。',
		titleInfo79: 'RWA Group或被其授權的任何員工可能會從事與平臺流通代幣相關的活動，盡管這些活動基於合法目的（包括但不限於提供代幣流動性、防止第三方惡意操縱市場等），您理解並同意這些活動與您構成可能的利益沖突。',
		titleInfo80: '4.3 流動性提供者',
		titleInfo81: '您承認、同意並接受：',
		titleInfo82: 'a. 我們可能會任命一個或多個流動性提供者（其中可能包括RWA Group本身）來監控和調整平臺流通代幣市場，並且任何此類流動性提供者可能會與您作為交易對手方進行任何交易；',
		titleInfo83: 'b. 流動性提供者還可能在其流動性提供活動中持有多種虛擬資產（包括平臺流通代幣等）的頭寸，包括與您頭寸相反的虛擬資產頭寸；',
		titleInfo84: 'c. 此類流動性提供活動可能通過算法交易進行。此類流動性提供可能會對平臺流通代幣的價格和執行交易所需的流動性產生影響；',
		titleInfo85: 'd. 流動性提供系基於合法目的（例如維持平臺市場穩定、防止第三方惡意操縱市場等），您不得因流動性提供行為對我們或與相關人員提出提出任何法律索賠、損害賠償或禁令申請；',
		titleInfo86: 'e. 我們在進行流動性提供時可能會實現利潤，也可能面臨損失，此類利潤或損失不構成對用戶的任何義務或責任。',
		titleInfo87: '5. 平臺流通代幣的購買和消費',
		titleInfo88: '平臺展示的關於平臺',
		titleInfo89: '流通代幣、商品或服務',
		titleInfo90: '的性質、品質和價格等信息僅為展示作用，不屬於邀約，至多為具體產品協議中標明的銷售商或代幣發行方發出的要約邀請。',
		titleInfo91: '當您在平臺購買或者消費平臺流通代幣以兌換商品或服務時，請您務必仔細確認所兌換商品或服務的品名、價格、數量、型號、規格以及尺寸，或權利的範圍、內容以及時間，或對兌換方的限製性要求等重要事項，並在兌換下單時核實您的賬戶名稱、電子郵箱以及收貨地址等信息。如您填寫的收貨信息並非您本人，收貨人的行為和意思表示視為您的行為和意思表示，您應對收貨人的行為及意思表示的法律後果承擔連帶責任。',
		titleInfo92: '您的消費行為應當基於真實的消費需求，不得存在對商品或服務實施惡意購買、惡意維權、惡意炒作等擾亂平臺正常交易秩序的行為。為維護平臺交易秩序及安全，RWA Group有權在發現上述情形時采取包括但不限於關閉訂單、限製賬戶、凍結資產等措施。',
		titleInfo93: '除非有明確的相反明示，當您在平臺購買、交易、消費平臺流通代幣以兌換實體商品或服務或進行其他平臺活動時，僅涉及您與銷售商或代幣發行方之間的法律關系，RWA Group不得以任何方式被認定為該法律關系的參與方。我們亦不對相關平臺流通代幣、代幣表征權益（商品、服務或其他非金融性權益）作出任何明示或暗示的陳述或保證，包括但不限於代幣的成功兌現、相應商品或服務的適銷性或特定用途的適用性。',
		titleInfo94: '您同意在任何情況下，不對RWA Group基於代幣消費行為等平臺活動提出任何意義的法律指控、損害賠償或禁令等。',
		titleInfo95: '6. 技術免責聲明',
		titleInfo96: '6.1 無任何陳述或擔保。',
		titleInfo97: '我們通過平臺提供的任何信息以及您與我們之間的通信，均以「現狀」和「可用」基礎提供，不作為任何準確性、完整性或時效性的陳述或擔保，無論是明示或暗示的，前述聲明在適用法律允許的最大範圍內有效。',
		titleInfo98: '具體來說，我們明確否認所有暗示擔保，包括但不限於所有權、適銷性、特定用途適用性和/或不侵犯他人權利的擔保。我們不保證您訪問或使用平臺及相關通信的持續性、穩定性或及時性，以及前述活動中涉及的任何材料內容的完整性、無誤性作出任何陳述或擔保。這可能導致您在一定時間內無法進行平臺流通代幣相關活動，並可能導致相關交易時間延遲。',
		titleInfo99: '6.2 暫停訪問。我們可能會不時暫停您對平臺的訪問或使用，以進行定期或緊急的安全維護。',
		titleInfo100: '7. 本協議及平臺的變更。我們可以在全權自行決定的情況下，隨時修改本協議以及平臺的任何內容，包括平臺流通代幣本協議以及相關活動的功能和內容。',
		titleInfo101: '您註冊平臺賬戶或繼續訪問、使用平臺，或購買、持有、消費或轉讓平臺流通代幣，即視為您已充分閱讀、理解並同意接受更新後的本協議。',
		titleInfo102: '如果您不希望接受任何變更，您應立即停止持有平臺流通代幣並停止進行任何平臺活動，並通過聯系RWA Group的相關人員註銷您的賬戶。',
		titleInfo103: '8. 合規合作。您同意配合RWA Group出於合規考慮就平臺流通代幣或平臺活動進行任何調查和調整。如有任何監管機構就平臺流通代幣或相關活動聯系您，您同意在適用法律允許的範圍內立即通知RWA Group，並提供所有相關信息。',
		titleInfo104: '9. 聲明和保證。您在此向我們聲明和保證，始終遵守以下事項：',
		titleInfo105: 'a. 您已經透過自身學習或咨詢專業法律人員或咨詢人員後，充分了解平臺業務以及平臺流通代幣的本質和任何風險;',
		titleInfo106: 'b. 您提供給我們的所有檔和信息在各方面均為真實、準確、完整並且最新的，我們在所有情況下可以依賴這些信息；',
		titleInfo107: 'c. 與本協議相關的所有決定完全和專門基於您自身的判斷，並在您獨立評估了您的財務資源、能力、願意承擔的相關風險和財務目標後做出；',
		titleInfo108: 'd. 您具備完全的權力、授權和能力：',
		titleInfo109: 'a) 訪問和使用平臺；',
		titleInfo110: 'b) 從事平臺流通代幣上的任何活動；',
		titleInfo111: 'c. 您已獲得所有必要的第三方同意、許可、授權、批準和協議，以及所有必需的、或希望獲得的政府監管機構、政府部門、委員會、代理機構或其他具有管轄權的組織的批準、同意、許可、註冊、聲明和報備，以便：',
		titleInfo112: 'a) 訪問和使用平臺；',
		titleInfo113: 'b) 從事平臺流通代幣上的任何活動；',
		titleInfo114: '10. 我們職責的性質。',
		titleInfo115: '您理解並同意，您與RWA Group之間的關系，或任何其他事項（包括但不限於您將資金存入平臺賬戶中），不構成任何信托、受托、代理或合夥關系，我們不對您承擔任何受托人義務。RWA Group有權因外部或內部商業原因，合理調整任何平臺流通代幣、產品或服務的價格及相關參數，而無需事先通知您。',
		titleInfo116: '我們亦不提供任何投資、法律、稅務、會計或財務建議，且不對平臺服務、平臺流通代幣以及平臺活動的市場表現以及監管批準作出保證，您應自行在相應司法管轄區履行判斷、決策及合規義務，並確認理解並接受使用平臺以及交易平臺流通代幣產生的相關風險。',
		titleInfo117: '除非特別明示說明，我們不得被以任何方式認定為平臺流通代幣的發行方和/或表征權益的銷售商，我們僅為平臺流通代幣的發行方和/或表征權益的銷售商和用戶建立了溝通渠道。',
		titleInfo118: '11. 補償。',
		titleInfo119: '您在此承諾並同意，在任何第三方、政府機關或行業組織向我們提出索賠、訴訟、行動、要求、爭議、指控或調查時，全額補償我們並使我們免於承擔任何索賠、責任、損害賠償（包括實際和間接損害賠償）、損失（包括任何直接或間接的金錢損失、名譽損失等）、成本和費用，包括但不限於所有利息、罰款以及法律和其他合理的律師費和其他專業費用（「賠償損失」），這些索賠或損失因以下任何事項產生或以任何方式與之相關：',
		titleInfo120: 'a. 您訪問或使用平臺或在平臺流通代幣上的任何活動；',
		titleInfo121: 'b. 您違反或涉嫌違反本協議或其他相關協議，包括任何產品協議；',
		titleInfo122: 'c. 您違反任何適用的法律；',
		titleInfo123: 'd. 您侵犯任何第三方的權利。',
		titleInfo124: '12. 責任',
		titleInfo125: '12.1 我們的責任。',
		titleInfo126: '在適用法律允許的最大範圍內，RWA Group對您或任何第三方因平臺活動或平臺流通代幣遭受的任何直接和間接損失不承擔任何責任。 在不影響前述規定的前提下，在任何情況下，RWA Group的責任總額不超過您在導致損失的事件發生之前的十二（12）個月內支付給RWA Group的費用金額。該金額將由我們支付給您，作為我們對所有損失和索賠的全部和最終賠償，並且足以解除我們對此類損失和索賠的全部責任。您承認並同意，RWA Group不了解與您相關的任何特殊情況，且前述金錢賠償為您唯一且充分的補救措施，您無權或放棄根據法律或衡平法要求任何其他索賠或救濟，包括但不限於任何損害賠償、物權主張、禁令和/或特定履行。',
		titleInfo127: '12.2 責任限製。',
		titleInfo128: '盡管本協議中的其他條款可能有不同規定，您在此承認並同意，在任何情況下，我們對您或任何其他個人或實體不承擔以下責任：',
		titleInfo129: 'a. 任何直接或間接的損失（包括金錢損失、商業機會損失等），無論系因以下事項引起的，還是與平臺流通代幣的其他任何事項相關：',
		titleInfo130: 'a) 任何風險警告中標明的風險（風險警告會不時更新）；',
		titleInfo131: 'b) 平臺流通代幣或平臺活動中涉及的其他虛擬資產底層協議的操作、功能、安全性或可用性',
		titleInfo132: 'c) 根據本協議的任何行動或不作為；',
		titleInfo133: 'd) 任何數據形式中的不準確性、缺陷或遺漏，任何此類數據的傳輸錯誤或延遲，以及任何此類數據的中斷；',
		titleInfo134: 'e) 我們進行的定期或不定期維護，包括由此產生的服務中斷和更改；',
		titleInfo135: 'f) 其他用戶的行為、不作為或違反本協議，以及任何其他第三方的行為所造成的損害；',
		titleInfo136: 'g) 平臺活動的任何終止、暫停、凍結或限製訪問；',
		titleInfo137: 'h) 我們無法通過您提供的聯系方式與您聯系；',
		titleInfo138: 'i) 我們拒絕或延遲執行任何指令；',
		titleInfo139: 'j) 您因第三方行為而遭受的損失，包括涉及RWA Group或平臺流通代幣的第三方詐騙;',
		titleInfo140: 'k) 任何區塊鏈網絡事件、分叉（Fork）或空投（Airdrop）；',
		titleInfo141: 'l) 由平臺或我們提供的產品或服務的正確性、質量、準確性、安全性、完整性、可靠性、性能、及時性、定價或持續可用性；由平臺或我們提供的任何內容的延遲、遺漏或錯誤；',
		titleInfo142: 'm) 您在平臺上進行的任何交易、指令或操作。',
		titleInfo143: 'b. 任何特殊的、懲罰性的、加重的、偶然的、間接的或後果性的損失或損害，無論系因我們的平臺、平臺流通代幣、本協議、產品協議，和/或根據本協議或與本協議相關的任何協議而產生的，或與之相關的；',
		titleInfo144: 'c. 您可能因明顯錯誤（Manifest Error）和/或極端市場（包括但不限於任何地域的虛擬資產市場、特定產品市場和金融市場）波動和/或任何交易的取消/修改而遭受的任何損失或損害，無論系直接仲系間接的、特殊的仲系後果性的，包括但不限於金錢損失和機會損失；和/或',
		titleInfo145: 'd. 您未通過正式法律行動在與索賠事項相關的事項發生之日起一年內提起的任何索賠。',
		titleInfo146: '12.3 溝通前置。',
		titleInfo147: '您同意在與我們產生任何糾紛時，在接觸任何監管機關或司法機關前，首先聯系我們以溝通關於糾紛的所有情況，您同意不會將任何糾紛相關的信息向第三方披露。',
		titleInfo148: '13. 適用法律和爭議解決。',
		titleInfo149: '本協議應受香港特別行政區法律的管轄，並按其解釋。您同意將所有此類爭議或索賠提交至香港特別行政區法院的專屬管轄並放棄對法院管轄權的任何異議。',
		titleInfo150: '如果RWA Group對您提起訴訟，RWA Group將通過您提供的電子郵件地址通知您。您同意，任何發送到該電子郵件地址或郵寄地址的通知都應視為有效，無論是否涉及服務的充分性。您有責任確保註冊賬戶時提供的電子郵件地址是最新和準確的。',
		titleInfo151: '雙方同意，所有與訴訟相關的信息應保持機密。盡管如此，一方可以在以下情況下披露此類機密信息：',
		titleInfo152: 'a. 如果獲得另一方書面同意；',
		titleInfo153: 'b. 在適用法律或任何有管轄權的監管或監督機構的規定要求下，或根據法院或其他有管轄權的權威機構的命令；',
		titleInfo154: 'c. 如果相關的機密信息已不再是機密信息，而是通過違反本協議以外的方式進入公共領域。',
		titleInfo155: '14. 集體訴訟放棄。',
		titleInfo156: '您和RWA Group同意，任何索賠應僅以個人名義提出，而非作為集體訴訟或代表訴訟中的原告或集體成員。您進一步同意放棄根據適用法律的允許範圍內，將此類索賠作為集體、集合、代表或私人檢察官訴訟的權利。未經 RWA Group同意，個人索賠不得合並或合並成單一訴訟。此放棄在適用法律允許的最大範圍內適用。',
		titleInfo157: '15. 協議終止。',
		titleInfo158: '本協議自您首次訪問平臺時起即對您具有法律約束力，並持續有效，直至您僅按照本協議所載明的賬戶註銷程序，正式註銷您的賬戶，方可終止本協議。若在協議終止後，您再次訪問平臺，協議將再次對您生效。協議終止後，本協議中非涉及平臺使用的條款繼續有效，這類條款包括但不限於本協議第8條至第14條（包括第8條和第14條本身）。',
		titleInfo159: '16. 其他',
		titleInfo160: '16.1完整協議。',
		titleInfo161: '本協議以及任何產品協議構成您與我們之間的完整協議。您確認，除非本協議或任何產品協議中明確規定，否則不會依賴於任何陳述、聲明、保證或擔保（無論是疏忽還是無意）。',
		titleInfo162: '16.2 轉讓。',
		titleInfo163: '在未獲得我們事先書面同意的情況下，您不得轉讓或轉移您在本協議下的任何權利或義務。任何未經授權的轉讓或轉移均屬無效，並不產生對RWA Group的約束力。然而，我們可能不時將本協議下的任何權利或義務轉讓或轉移給任何其他方，包括但不限於與RWA Group任一主體的合並、收購或其他公司重組相關的情況。',
		titleInfo164: '16.3 無效性。',
		titleInfo165: '本協議的每一部分在判斷其合法性、有效性或可執行性時，應可與本協議中的其他部分分開。如果本協議的任何部分在任何時候變得非法、無效或無法執行，則其余部分的合法性、有效性或可執行性不會因此受到影響或損害。',
		titleInfo166: '16.4 語言。',
		titleInfo167: '為便於閲讀，可能會提供本協議的翻譯版本，翻譯版本可能采用除英語以外的其他語言。然而，英語版本的本協議為正式版本，您應確保完全理解英語版本；因未理解而導致的風險或損失由您自行承擔。',
		titleInfo168: '16.5 存續。',
		titleInfo169: '盡管您在平臺上的活動可能已被暫停或終止，但本協議以及任何適用的產品協議仍會在您根據本協議或任何適用產品協議需要履行義務或責任時繼續適用於您。',
		titleInfo170: '16.6 不放棄。',
		titleInfo171: '我們在行使本協議下的任何權利或救濟時的任何延遲或遺漏，不應視為放棄未來行使該權利或救濟，或放棄本協議下的任何其他權利或救濟。本協議中提供的權利和救濟是累積性的，不排除適用法律提供的任何權利或救濟。除非以書面形式作出並經RWA Group簽署，否則任何放棄均不視為有效。',
		titleInfo172: '16.7 稅務。',
		titleInfo173: '確定您所支付或收到的款項是否適用稅收以及收取、報告和上繳正確稅款的責任在於您。您同意，我們不負責確定您的平臺流通代幣活動是否適用任何稅收，也不負責收取、報告或上繳任何由此產生的稅款。您應獨立向相關稅務機關申報並繳納因平臺活動產生的稅款，我們不承擔任何連帶責任。',
		titleInfo174: '16.8 隱私。',
		titleInfo175: '我們致力於確保通過平臺提交的所有個人數據嚴格遵守《個人資料(私隱)條例》（PDPO）的相關規定。由於不同的目的，您可能不時被邀請通過平臺或其他方式向RWA Group提供個人數據。個人信息可能包括姓名、電話號碼、郵寄地址或電子郵件地址。RWA Group會在邀請您提供此類信息時明確幫助收集目的和用途。除非法律允許或要求，否則RWA Group不會在未獲得您事先同意的情況下將您的個人數據披露給任何第三方。',
	},
	...zhLocale
}
export default zh;